import moment from 'moment';
import pluralize from 'pluralize';
import { forwardRef } from 'react';

import { breedsToShortString, listingPath } from './shared/listing_helpers';
import PopoverShare from './PopoverShare';
import FavoriteToggle from './listing_card/FavoriteToggle';
import ContributorStats from './listing_card/ContributorStats';
import ContributorExpirationBar from './listing_card/ContributorExpirationBar';

const shortDate = (date) => moment(date).format('M/D/YYYY');

export default forwardRef(function ListingCard({
  listing, moved, contributor, adopter, favorite, active, viewable=contributor, noToggler, userType, userID, onClick
}, ref) {
  const {
    slug, name, gender, breeds, age, height, location, cover,
    status, status_reason, status_changed_at
  } = listing;

  return (
    <a
      ref={ref}
      href={viewable && slug ? listingPath(slug) : "#"}
      className={classnames("card listing-card", {moved})}
      disabled={!viewable}
      onClick={onClick}
    >
      <div className="card-body">
        <img src={cover} className="listing-card-image" alt=""/>

        {active && <>
          {!noToggler && slug && <PopoverShare {...{userType, userID, listing}}/>}
          {contributor && <ContributorStats listing={listing}/>}
        </>}
        {adopter && <FavoriteToggle listing={listing} favorite={favorite}/>}

        <h5 className="card-title">{name}</h5>
        <div className="card-text">
          {location && (
            <p className="listing-data">{location.city}, {location.state}</p>
          )}
          <p className="listing-data">
            {_.compact([
              breedsToShortString(breeds),
              gender,
              (age && pluralize('year', age, true)),
              (height && `${height} HH`)
            ]).join(' / ')}
          </p>

          {!viewable && (
            <p className="listing-data">
              <em className="listing-expiration">This horse has been adopted!</em>
            </p>
          )}
          {contributor && <>
            <ContributorExpirationBar listing={listing}/>
            {status_reason && (
              <p className="listing-data">
                {status == 'stalled' && 'In '}{status_reason}: {shortDate(status_changed_at)}
              </p>
            )}
          </>}
          {active && noToggler && (
            <PopoverShare userType={userType} userID={userID} listing={listing} noToggler/>
          )}
        </div>
      </div>
    </a>
  );
})
